import React, { FC, useMemo } from 'react'

import { useDispatch } from 'react-redux'

import {
  photoViewerBasePath,
  promoValuePath,
} from 'components/page/PhotoViewer/PhotoViewer.paths'
import { PhotoViewerNoticeIndex } from 'components/page/PhotoViewer/PhotoViewerNotice/PhotoViewerNoticeIndex'
import { Title } from 'components/page/PhotoViewer/PhotoViewerNotice/PhotoViewerNoticeTitle'
import { ratingPath } from 'components/page/RatingWave/Rating.paths'
import { chatPath, contactPath, profilePath } from 'components/paths'
import {
  giftPresentPath,
  storeFrontGiftsPath,
  storeFrontUserPath,
} from 'components/storefront/StoreFront.paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { push, replace } from 'functions/router'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useLayoutContext } from 'hooks/useLayoutContext'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const PhotoViewerNoticeMain: FC<{
  userId: string
  selectedPhotoIndex: number
}> = ({ userId, selectedPhotoIndex }) => {
  const dispatch = useDispatch()
  const { baseUrl } = useLayoutContext()
  const { authorized, name, gender, photos } = useShallowEqualSelector(
    ({
      authorizationReducer: { authorized },
      photoViewerReducer: { name, gender, photos },
    }) => ({
      authorized,
      name,
      gender,
      photos,
    })
  )

  /**
   * https://youtrack.mamba.ru/issue/M-10969
   * Для вот таких случаев для rating
   */
  const _baseBackUrl = useMemo(
    () =>
      baseUrl.includes(ratingPath)
        ? mergeAllUrls(baseUrl, profilePath, userId)
        : baseUrl,
    [baseUrl, userId]
  )

  const authorizationPath = useAuthorizationPath()
  const openAuthorization = () => dispatch(push(authorizationPath))

  const handleSendGift = () => {
    if (authorized) {
      /**
       * Делаем replace, чтобы потом вернуться на последнюю фотку.
       */
      dispatch(
        replace(
          mergeAllUrls(
            _baseBackUrl,
            photoViewerBasePath,
            photos[selectedPhotoIndex].photoId,
            promoValuePath
          )
        )
      )
      return dispatch(
        push(
          mergeAllUrls(
            baseUrl,
            storeFrontGiftsPath,
            storeFrontUserPath,
            userId,
            giftPresentPath
          )
        )
      )
    }
    openAuthorization()
  }

  const handleSendMessage = () => {
    if (!authorized) {
      return openAuthorization()
    }

    dispatch(push(mergeAllUrls(chatPath, userId, contactPath)))
  }

  return (
    <PhotoViewerNoticeIndex
      onSendGift={handleSendGift}
      onSendMessage={handleSendMessage}
      title={<Title name={name} gender={gender} />}
    />
  )
}
